import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">ICCAC</h3>
            <p className="text-gray-300 text-sm">
              International Consciousness & Coaching Accreditation Council - The Global Standard for Consciousness-Based Coaching
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/accreditation" className="text-gray-300 hover:text-white transition-colors">Accreditation</Link></li>
              <li><Link to="/certifications" className="text-gray-300 hover:text-white transition-colors">Certifications</Link></li>
              <li><Link to="/find-coach" className="text-gray-300 hover:text-white transition-colors">Find a Coach</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/standards" className="text-gray-300 hover:text-white transition-colors">Standards & Ethics</Link></li>
              <li><Link to="/membership" className="text-gray-300 hover:text-white transition-colors">Membership</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>General Enquiries:</li>
              <li><a href="mailto:info@iccacouncil.com" className="hover:text-white transition-colors">info@iccacouncil.com</a></li>
              <li className="pt-2">Accreditation:</li>
              <li><a href="mailto:accreditation@iccacouncil.com" className="hover:text-white transition-colors">accreditation@iccacouncil.com</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} ICCAC - International Consciousness & Coaching Accreditation Council. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;